import {ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {AuthPageHeader} from './AuthPageHeader';
import {AuthPageLoader} from 'pages/Auth/components/AuthPageLoader';
import {
  Footer,
  FooterLink,
  Container,
  Title,
  Subtitle,
  MainContent,
  Wrapper,
  ContentWrapper,
} from './styled';

interface Props {
  title?: string;
  subtitle?: ReactNode;
  children: ReactNode;
  onClickLogo?: () => void;
  isLoading?: boolean;
}

export const AuthPage = ({title, subtitle, children, onClickLogo, isLoading}: Props) => {
  const {t} = useTranslation();

  return (
    <Wrapper>
      {isLoading && <AuthPageLoader />}

      <ContentWrapper $isLoading={isLoading}>
        <AuthPageHeader onClickLogo={onClickLogo} />

        <Container>
          <MainContent>
            {title && <Title>{title}</Title>}
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
            {children}
          </MainContent>
          <Footer>
            <FooterLink
              label={t('terms_of_use')}
              to={t('guest_terms_of_use_link')}
              openNewTab
              link
            />
            <FooterLink
              label={t('privacy_policy')}
              to={t('guest_privacy_policy_link')}
              openNewTab
              link
            />
          </Footer>
        </Container>
      </ContentWrapper>
    </Wrapper>
  );
};
